import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import Layout from "@/layout/index.vue"

Vue.use(VueRouter)

const routes = [ 
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/login/index.vue'),
    meta: {title: '登录', icon: 'user', minLevel: 0},
  },
  {
    path: '/',
    name: 'Layout',
    redirect:'/index',
    component: Layout,
    meta: {title: 'home', icon: 'user', minLevel: 1},
  },
  {
    path: '/index',
    name: 'index',
    component: Layout,
    redirect: '/index/dataPersent',
    meta: {title: 'home', icon: 'user', minLevel: 1},
    children: [
      //在线折线图表
      {
        path: 'lineChart',
        name: 'lineChart',
        component: () => import('@/views/index/online/index'),
        meta: {title: '在线折线图', icon: 'list', minLevel: 9}
      },
      //在线数据占比
      {
        path: 'dataPersent',
        name: 'dataPersent',
        component: () => import('@/views/index/online/datapersent'),
        meta: {title: '在线数据占比', icon: 'list', minLevel: 2}
      },
    ]
  },
  {
    path: '/appversion',
    name: 'appversion',
    component: Layout,
    redirect: '/appversion/appversionList',
    meta: {title: '用户', icon: 'user', minLevel: 9},
    children: [
      //管理列表
      {
        path: 'appversionList',
        name: 'appversionList',
        component: () => import('@/views/appversion/list/index'),
        meta: {title: '管理列表', icon: 'list', minLevel: 9}
      },
      {
        path: 'updateAppversion',
        name: 'updateAppversion',
        component: () => import('@/views/appversion/list/update'),
        meta: {title: '管理修改', icon: 'list', minLevel: 9}
      },
      {
        path: 'addAppversion',
        name: 'addAppversion',
        component: () => import('@/views/appversion/list/add'),
        meta: {title: '创建管理', icon: 'list', minLevel: 9}
      },
      {
        path: 'suggestions',
        name: 'suggestions',
        component: () => import('@/views/appversion/suggestions/index'),
        meta: {title: '创建管理', icon: 'list', minLevel: 9}
      },
    ]
  },
  {
    path: '/admin',
    name: 'admin',
    component: Layout,
    redirect: '/admin/adminList',
    meta: {title: '用户', icon: 'user', minLevel: 9},
    children: [
      //管理列表
      {
        path: 'adminList',
        name: 'adminList',
        component: () => import('@/views/admin/list/index'),
        meta: {title: '管理列表', icon: 'list', minLevel: 9}
      },
      {
        path: 'updateAdmin',
        name: 'updateAdmin',
        component: () => import('@/views/admin/list/update'),
        meta: {title: '管理修改', icon: 'list', minLevel: 9}
      },
      {
        path: 'addAdmin',
        name: 'addAdmin',
        component: () => import('@/views/admin/list/add'),
        meta: {title: '创建管理', icon: 'list', minLevel: 9}
      },
    ]
  },
  {
    path: '/user',
    name: 'user',
    component: Layout,
    redirect: '/user/userList',
    meta: {title: '用户', icon: 'user', minLevel: 9},
    children: [
      //用户列表
      {
        path: 'userList',
        name: 'userList',
        component: () => import('@/views/user/list/index'),
        meta: {title: '用户列表', icon: 'list', minLevel: 9}
      },
      {
        path: 'updateUser',
        name: 'updateUser',
        component: () => import('@/views/user/list/update'),
        meta: {title: '用户修改', icon: 'list', minLevel: 9}
      },
    ]
  },
  {
    path: '/sounds',
    name: 'sounds',
    component: Layout,
    redirect: '/sounds/soundsList',
    meta: {title: '音效', icon: 'sounds', minLevel: 2},
    children: [
      //音效列表
      {
        path: 'soundsList',
        name: 'soundsList',
        component: () => import('@/views/sounds/list/index'),
        meta: {title: '音效列表', icon: 'list'}
      },
      {
        path: 'updateSound',
        name: 'updateSound',
        component: () => import('@/views/sounds/list/update'),
        meta: {title: '修改音效', icon: 'list'}
      },
      {
        path: 'setKeywords',
        name: 'setKeywords',
        component: () => import('@/views/sounds/list/setKeywords.vue'),
        meta: {title: '批量设置关键词', icon: 'list'}
      },
      {
        path: 'addSound',
        name: 'addSound',
        component: () => import('@/views/sounds/list/add'),
        meta: {title: '添加音效', icon: 'list'}
      },
      //用户搜索音效关键词分析
      {
        path: 'userSearchLog',
        name: 'userSearchLog',
        component: () => import('@/views/sounds/userSearchLog/index'),
        meta: {title: '搜索关键词分析', icon: 'list'}
      },
      {
        path: 'findSound',
        name: 'findSound',
        component: () => import('@/views/sounds/findSound/index'),
        meta: {title: '找音效', icon: 'list'}
      },
      {
        path: 'answerFindSound',
        name: 'answerFindSound',
        component: () => import('@/views/sounds/findSound/answer'),
        meta: {title: '回复找音效', icon: 'list'}
      },
      //分类
      {
        path: 'category',
        name: 'category',
        component: () => import('@/views/sounds/category/index'),
        meta: {title: '基础分类', icon: 'product-add'}
      },
      {
        path: 'tags',
        name: 'soundTags',
        component: () => import('@/views/sounds/tag/index'),
        meta: {title: '标签与搜索词', icon: 'el-icon-collection-tag'}
      },
      {
        path: 'rights',
        name: 'soundRights',
        component: () => import('@/views/sounds/rights/index'),
        meta: {title: '版权与展示控制', icon: 'el-icon-document-checked'}
      },
      {
        path: 'complaints',
        name: 'soundComplaints',
        component: () => import('@/views/sounds/complaint/index'),
        meta: {title: '资源问题反馈', icon: 'el-icon-warning-outline'}
      },
      
      {
        path: 'addCategory',
        name: 'addCategory',
        component: () => import('@/views/sounds/category/add'),
        meta: {title: '添加分类', icon: 'product-add'}
      },

      {
        path: 'updateCategory',
        name: 'updateCategory',
        component: () => import('@/views/sounds/category/update'),
        meta: {title: '修改分类', icon: 'product-add'}
      },
    ]
  },

  // 2026-10-05：话术维护独立入口；接口也要求最高管理员，隐藏菜单不代替权限校验。
  {
    path: '/support',
    name: 'support',
    component: Layout,
    redirect: '/support/phrases',
    meta: { title: '客服话术', icon: 'el-icon-chat-line-square', minLevel: 9 },
    children: [
      {
        path: 'phrases',
        name: 'supportPhrases',
        component: () => import('@/views/support/phrases.vue'),
        meta: { title: '话术与分类', icon: 'el-icon-chat-line-square', minLevel: 9 }
      }
    ]
  },
  {
    path: '/assets',
    name: 'assets',
    component: Layout,
    redirect: '/assets/images',
    meta: { title: '资源管理', icon: 'el-icon-folder-opened', minLevel: 2 },
    children: [
      {
        path: 'images',
        name: 'imageAssetLibrary',
        component: () => import('@/views/assets/images/index.vue'),
        meta: { title: '图片资源库', icon: 'el-icon-picture-outline', minLevel: 2 }
      },
      {
        path: 'image-files',
        name: 'imageFileManager',
        component: () => import('@/views/assets/image-files/index.vue'),
        meta: { title: '图片文件管理器', icon: 'el-icon-files', minLevel: 2 }
      }
    ]
  },

  {
    path: '/sounds_v2',
    component: Layout,
    redirect: '/sounds_v2/menus',
    name: 'Soundsv2',
    meta: { title: '音效管理', icon: 'el-icon-s-help', minLevel: 2},
    children: [
      {
        path: 'menus',
        name: 'menus',
        component: () => import('@/views/sounds_v2/menu/menus'),
        meta: { title: '音效分类', icon: 'table' }
      },
      {
        path: 'add_menus',
        name: 'add_menus',
        component: () => import('@/views/sounds_v2/menu/add'),
        meta: { title: '添加音效分类', icon: 'table' }
      },
      {
        path: 'edit_menu',
        name: 'edit_menu',
        component: () => import('@/views/sounds_v2/menu/edit'),
        meta: { title: '修改音效分类', icon: 'table' },
        hidden:true,
      },
      {
        path: 'table',
        name: 'Table',
        component: () => import('@/views/sounds_v2/index'),
        meta: { title: '音效列表', icon: 'table' }
      },
      // {
      //   path: 'upload',
      //   name: 'upload',
      //   component: () => import('@/views/sounds_v2/upload'),
      //   meta: { title: '上传新音效', icon: 'table' }
      // },
    ]
  },

  {
    path: '/app_setting',
    component: Layout,
    redirect: '/app_setting/update',
    name: 'appSeting',
    meta: { title: '软件设置', icon: 'el-icon-s-help', minLevel: 9 },
    children: [
      {
        path: 'update',
        name: 'app_setting_update',
        component: () => import('@/views/app/update'),
        meta: { title: '通用设置', icon: 'table', minLevel: 9 }
      },
      {
        path: 'trial_config',
        name: 'app_setting_trial_config',
        component: () => import('@/views/app/trial-config.vue'),
        meta: { title: '试用配置', icon: 'table', minLevel: 9 }
      },
      {
        path: 'license_config',
        name: 'app_setting_license_config',
        component: () => import('@/views/app/license-config.vue'),
        meta: { title: '授权配置', icon: 'el-icon-lock', minLevel: 9 }
      },
    ]
  },

  {
    path: '/license',
    component: Layout,
    redirect: '/license/features',
    name: 'license',
    meta: { title: '会员权限', icon: 'el-icon-lock', minLevel: 9 },
    children: [
      {
        path: 'features',
        name: 'licenseFeatures',
        component: () => import('@/views/license/features.vue'),
        meta: { title: '功能权限', icon: 'table', minLevel: 9 }
      },
      {
        path: 'plans',
        name: 'licensePlans',
        component: () => import('@/views/license/plans.vue'),
        meta: { title: '会员套餐', icon: 'table', minLevel: 9 }
      },
      {
        path: 'plan-edit',
        name: 'licensePlanEdit',
        component: () => import('@/views/license/plan-edit.vue'),
        meta: { title: '编辑套餐', icon: 'table', minLevel: 9, sidebarHidden: true }
      },
      {
        path: 'activation-codes',
        name: 'licenseActivationCodes',
        component: () => import('@/views/license/activation-codes.vue'),
        meta: { title: '激活码生成', icon: 'table', minLevel: 9 }
      },
    ]
  },


  //代理
  {
    path: '/agents',
    name: 'agents',
    component: Layout,
    redirect: '/agents/agentsList',
    meta: {title: '代理', icon: 'sounds', minLevel: 9},
    children: [
      //代理列表
      {
        path: 'agentsList',
        name: 'agentsList',
        component: () => import('@/views/agents/list/index'),
        meta: {title: '代理列表', icon: 'list', minLevel: 9}
      },
      {
        path: 'update',
        name: 'updateAgent',
        component: () => import('@/views/agents/list/update'),
        meta: {title: '修改代理', icon: 'list', minLevel: 9}
      },
      {
        path: 'add',
        name: 'addAgent',
        component: () => import('@/views/agents/list/add'),
        meta: {title: '添加代理', icon: 'list', minLevel: 9}
      },
    ]
  },

  //SKU 管理
  {
    path: '/codetypes',
    name: 'codetypes',
    component: Layout,
    redirect: '/codetypes/list',
    meta: {title: 'SKU管理', icon: 'sounds', minLevel: 9},
    children: [
      {
        path: 'list',
        name: 'codetypeList',
        component: () => import('@/views/codetypes/list/index'),
        meta: {title: 'SKU列表', icon: 'list', minLevel: 9}
      },
      {
        path: 'update',
        name: 'updateCodeType',
        component: () => import('@/views/codetypes/list/update'),
        meta: {title: '编辑SKU', icon: 'list', minLevel: 9}
      },
      {
        path: 'add',
        name: 'addCodeType',
        component: () => import('@/views/codetypes/list/add'),
        meta: {title: '新增SKU', icon: 'list', minLevel: 9}
      },
    ]
  },
  {
    path: '/403',
    name: '403',
    component: () => import('@/views/errorPage/403.vue'),
    meta: { title: '无权限', hidden: true }
  }

  // {
  //   path: '/test',
  //   name: 'test',
  //   component: () => import('@/views/wavesurfer.vue'),
  // },
]

const router = new VueRouter({
  routes
})

export default router
